/** Formatowanie czasu pracy — minuty w bazie, godziny i minuty w UI. */

/** 90 → „1 h 30 min", 120 → „2 h", 45 → „45 min". */
export function formatMinutes(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined || Number.isNaN(minutes)) return '—'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m} min`
  if (m === 0) return `${h} h`
  return `${h} h ${m} min`
}

/** 8550 minut → „142,5" (godziny dziesiętnie, polski przecinek, bez zbędnego zera). */
export function formatHoursDecimal(minutes: number): string {
  return new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 1 }).format(minutes / 60)
}

/** Dzisiejsza data LOKALNA jako `YYYY-MM-DD` (toISOString przesuwałoby dobę przez UTC). */
export function todayIso(): string {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${day}`
}
